/** Admin Project → Notes: notes + photos sent from the field app. */
import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { Camera, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { SiteNoteCard, PhotoLightbox } from '../../pages/portal/PortalSiteNotes';

export function FieldSiteNotes({ projectId, api }) {
  const [items, setItems] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const load = useCallback(async () => {
    try { const r = await api.get(`/projects/${projectId}/site-notes`); setItems(r.data || []); }
    catch { setItems([]); }
  }, [api, projectId]);
  useEffect(() => { load(); }, [load]);

  const remove = async (note) => {
    if (!window.confirm('Remove this field note and its photos?')) return;
    try { await api.delete(`/portal/site-notes/${note.id}`); toast.success('Removed'); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="mt-8" data-testid="field-site-notes">
      <h2 className="text-xl font-bold text-white mb-3" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
        <Camera className="w-5 h-5 inline-block mr-2 text-[#F5A623]" />
        From the field ({items?.length ?? '…'})
      </h2>
      {items === null ? <Loader2 className="w-5 h-5 animate-spin text-gray-400" /> : items.length === 0 ? (
        <p className="text-gray-500 text-sm" data-testid="field-site-notes-empty">No site notes or photos from the team yet.</p>
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {items.map(n => <SiteNoteCard key={n.id} note={n} showProject={false} onDelete={remove} onOpenPhoto={(note, idx) => setLightbox({ src: `/portal/site-notes/${note.id}/photos/${idx}`, title: `${note.user_name} · ${format(new Date(note.created_at), 'd MMM HH:mm')}` })} />)}
        </div>
      )}
      <PhotoLightbox open={!!lightbox} onClose={() => setLightbox(null)} src={lightbox?.src} title={lightbox?.title} />
    </div>
  );
}
